import axios from "axios";
import toast from "react-hot-toast";
import { base_url } from "../variables/constants";

const getServices = async (url, access_token) => {
  try {
    const res = await axios.get(`${base_url}${url}`, {
      headers: { Authorization: access_token },
    });
    return res.data;
  } catch (error) {
    toast.error(error);
  }
};

const postServices = async (url, data, access_token) => {
  try {
    const res = await axios.post(`${base_url}${url}`, data, {
      headers: { Authorization: access_token },
    });
    return res.data;
  } catch (error) {
    toast.error(error.message);
  }
};

const putServices = async (url, data, access_token) => {
  try {
    const res = await axios.put(`${base_url}${url}`, data, {
      headers: { Authorization: access_token },
    });
    return res.data;
  } catch (error) {
    toast.error(error.message);
  }
};

const deleteServices = async (url, access_token) => {
  try {
    const res = await axios.delete(`${base_url}${url}`, {
      headers: { Authorization: access_token },
    });
    return res.data;
  } catch (error) {
    toast.error(error.message);
  }
};

export { getServices, postServices, putServices, deleteServices };
